import { WithStyleOverrides } from '@opallabs/lapidary'

export const EvenColumns: React.FC<
  React.PropsWithChildren<WithStyleOverrides>
> = ({ children, styleOverrides }) => {
  return (
    <div
      css={{
        display: 'grid',
        // Using minmax with 0 to prevent grid contents
        // from overflowing 1fr's worth of space
        gridAutoColumns: 'minmax(0, 1fr)',
        gridAutoFlow: 'column',
        gridTemplateRows: '100%',
        ...styleOverrides,
      }}
    >
      {children}
    </div>
  )
}
